import React from "react";

const Resume = () => {
  return (
    <div className="page pt-resume" data-simplebar="">
      <section className="container">
        {/* Section Title */}
        <div className="header-page mt-70 mob-mt">
          <h2>Resume</h2>
          <span></span>
        </div>

        {/* Experience & Education Row Start */}
        <div className="row mt-100">
          {/* Experience Column Start */}
          <div className="col-lg-6 col-sm-12">
            {/* Header Block  */}
            <div className="header-box mb-50">
              <h3>Experience</h3>
            </div>

            <div className="experience box-1">

                            {/* Experience Item */}
                            <div className="item">
                <div className="main">
                  <h4>MERN Stack Developer</h4>
                  <p>
                    <i className="far fa-calendar-alt"></i>Apr 2020 - On going |
                    Techify Solutions Pvt Ltd 
                  </p>
                </div>
                <p>
                  <strong>Front-end (React.js & React-Native):</strong> I have worked on 4 to 5 projects and provided solutions for react and react native applications.
                </p>
              </div>

              {/* Experience Item */}
              <div className="item">
                <div className="main">
                  <h4>MERN Stack Developer</h4>
                  <p>
                    <i className="far fa-calendar-alt"></i>Jun 2019 -Feb 2020 |
                    Rao Information Technology
                  </p>
                </div>
                <p>
                  <strong>Front-end (React.js & React-Native):</strong> I am
                  able to create react website and also react-native
                  application.I have good knowledge of hooks and
                  redux(redux-saga/redux-thunk) and how to integrate it with
                  React application.
                </p>
                <p>
                  <strong>Back-end:</strong> NodeJs + SQL/NoSQL database.I
                  worked with several projects using Node(Express) + MongoDB
                  (Mongoose)/ MySQL(Knex).
                </p>
              </div>

              {/* Experience Item  */}
              <div className="item">
                <div className="main">
                  <h4>Software Developer</h4>
                  <p>
                    <i className="far fa-calendar-alt"></i>Dec 2018 - Jun 2019 |
                    Acute Informatics Pvt. Ltd.
                  </p>
                </div>
                <p>
                  <strong>Front-end:</strong> Worked with power-builder software
                  which was used for develop banking software and totally
                  dependent on power-script language.
                </p>
                <p>
                  <strong>Back-end:</strong> Java + Oracle.I have gain knowledge
                  of how back-end works using java as server and Oracle as
                  database. Android Apk: we also worked on project called
                  easy-way-banking which is banking application which provides
                  banking solutions.
                </p>
              </div>

              {/* Experience Item  */}
              {/* <div className="item">
                              <div className="main">
                                <h4>Web Development</h4>
                                <p><i className="far fa-calendar-alt"></i>2015 - 2019 | Сompany Inc</p>
                              </div>
                              <p>Work experience is essential for getting a job. Whether it's a short work placement or a longer internship, work experience is always viewed favourably by employers and can help you decide your future career.</p>
                            </div> */}
            </div>
          </div>

          {/* Education Column Start */}
          <div className="col-lg-6 col-sm-12">
            {/* Header Block */}
            <div className="header-box mb-50 mob-box-mt">
              <h3>Education</h3>
            </div>

            <div className="experience box-2">
              {/* Education Item */}
              <div className="item">
                <div className="main">
                  <h4>Gradution</h4>
                  <p>
                    <i className="far fa-calendar-alt"></i>2015 - 2019 |
                    Government Engineering College, Rajkot
                  </p>
                </div>
                <p>Computer engineering / Bachelor of engineering</p>
                <p>CGPA: 7.86</p>
              </div>

              {/* Education Item */}
              <div className="item">
                <div className="main">
                  <h4>Science</h4>
                  <p>
                    <i className="far fa-calendar-alt"></i>2013 - 2015 | Swami
                    Vivekananda School,Junagadh
                  </p>
                </div>
                <p>Percentage: 62.20%</p>
              </div>

              {/* Education Item */}
              <div className="item">
                <div className="main">
                  <h4>10th Standard</h4>
                  <p>
                    <i className="far fa-calendar-alt"></i>2012 - 2013| Swami
                    Vivekananda School,Junagadh
                  </p>
                </div>
                <p>Percentage: 86.33%</p>
              </div>
            </div>
          </div>
        </div>

        {/* Skills Row Start */}
        <div className="row mt-100">
          {/* Header Block  */}
          <div className="col-md-12">
            <div className="header-box mb-50">
              <h3>Skills</h3>
            </div>
          </div>
        </div>

        <div className="box-1 skills">
          <div className="row">
            <div className="col-lg-6 col-sm-6">
              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">HTML </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }}>
                    <div className="progress-value">100%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">CSS </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "90%" }}>
                    <div className="progress-value">90%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">JavaScript </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "90%" }}>
                    <div className="progress-value">90%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">Node.js </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "80%" }}>
                    <div className="progress-value">80%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">React.js </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "95%" }}>
                    <div className="progress-value">95%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">Redux </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "100%" }}>
                    <div className="progress-value">100%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">React-Native </h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "80%" }}>
                    <div className="progress-value">80%</div>
                  </div>
                </div>
              </div>

              {/* Skill Item  */}
              <div className="skill-item">
                <h4 className="progress-title">Sql/NoSql</h4>
                <div className="progress">
                  <div className="progress-bar" style={{ width: "60%" }}>
                    <div className="progress-value"> 60%</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-sm-6">
              <div className="row">
                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="100"
                    data-bar-color="#fff"
                  >
                    {" "}
                    100% <p>HTML</p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="90"
                    data-bar-color="#fff"
                  >
                    {" "}
                    90% <p>CSS</p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="90"
                    data-bar-color="#fff"
                  >
                    {" "}
                    90% <p>JavaScript</p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="80"
                    data-bar-color="#fff"
                  >
                    {" "}
                    80% <p>Node.js</p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="95"
                    data-bar-color="#fff"
                  >
                    {" "}
                    95% <p>React.js</p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="100"
                    data-bar-color="#fff"
                  >
                    {" "}
                    100% <p>Redux</p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="80"
                    data-bar-color="#fff"
                  >
                    {" "}
                    80%{" "}
                    <p className="m-2" style={{ fontSize: 13 }}>
                      React-Native
                    </p>
                  </div>
                </div>

                {/* Skill Item   */}
                <div className="col-lg-6 col-sm-6">
                  <div
                    className="chart"
                    data-percent="60"
                    data-bar-color="#fff"
                  >
                    {" "}
                    60% <p className="m-2">Sql/NoSql</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Work Process Row Start */}
        <div className="row mt-100">
          {/* Header Block  */}
          <div className="col-md-12">
            <div className="header-box mb-50">
              <h3>My Learning Process</h3>
            </div>
          </div>
        </div>

        <div className="box-2 work-process mb-100">
          <div className="row">
            <div className="col-lg-4 col-sm-12 ">
              {/* Working Process Item */}
              <div className="single-wp width-sm process-1">
                <p className="wp-step">01</p>
                <h4 className="wp-title">Complete the Basic concepts</h4>
                <p>
                  When i started learning MERN Stack Development first i
                  completed HTML & CSS & JavaScript from{" "}
                  <a target="blank" href="https://www.w3schools.com/">
                    w3Schools
                  </a>{" "}
                  website.
                </p>
              </div>
            </div>

            <div className="col-lg-4 hidden-sm">
              {/* Working Process Circle */}
              <div className="wp-circle">
                <h4>My Learning Process</h4>
                <span className="dots top-l"></span>
                <span className="dots bottom-l"></span>
                <span className="dots top-r"></span>
                <span className="dots bottom-r"></span>
              </div>
            </div>

            <div className="col-lg-4 col-sm-12 ">
              {/* Working Process Item */}
              <div className="single-wp width-sm process-2">
                <p className="wp-step">02</p>
                <h4 className="wp-title">Move to the Next level</h4>
                <p>
                  After completeing basics i completed React.js & React-Native &
                  Node.js Courses from Udemy and official website.
                </p>
              </div>
            </div>
            {/* <div className="col-lg-4 col-sm-12 rtl"> 

                            {/* Working Process Item
                            <div className="single-wp width-sm process-3">
                              <p className="wp-step">03</p>
                              <h4 className="wp-title">Web concept</h4>
                              <p>I could describe these conceptions, also impress upon paper all that is living.</p>
                            </div>

                            {/* Working Process Item 
                            <div className="single-wp width-sm process-4">
                              <p className="wp-step">04</p>
                              <h4 className="wp-title">Final concept</h4>
                              <p>I could describe these conceptions, also impress upon paper all that is living.</p>
                            </div>
                           </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resume;
